/**
 * `exhibitions` — expositions, foires et événements (base galerie, 4.1).
 */
import { z } from 'zod';
import { bilingueSchema, CHAMPS_DOCUMENT, idSchema, slugSchema, withAudit } from './commun.js';
export const TYPES_EXPOSITION = ['exposition', 'foire', 'evenement'];
export const typeExpositionSchema = z.enum(TYPES_EXPOSITION);
export const ETATS_EXPOSITION = ['brouillon', 'annoncee', 'en_cours', 'passee'];
export const etatExpositionSchema = z.enum(ETATS_EXPOSITION);
export const exhibitionSchema = withAudit(z.object({
    _id: idSchema,
    type: typeExpositionSchema.default('exposition'),
    titre: bilingueSchema,
    slug: slugSchema,
    debutLe: z.date(),
    finLe: z.date(),
    vernissageLe: z.date().optional(),
    lieuId: idSchema.optional(),
    stand: z.string().optional(),
    texte: bilingueSchema.optional(),
    oeuvres: z.array(idSchema).default([]),
    artistes: z.array(idSchema).default([]),
    medias: z.array(idSchema).default([]),
    etat: etatExpositionSchema.default('brouillon'),
    visibleSurLeSite: z.boolean().default(false),
}));
export const exhibitionCreationSchema = exhibitionSchema.omit(CHAMPS_DOCUMENT);
export const exhibitionMiseAJourSchema = exhibitionCreationSchema.partial();
//# sourceMappingURL=exhibitions.js.map